import { Badge } from "@devhop/ui";
import { Building2, Users } from "lucide-react";
import { useSOPSUsage } from "../api/queries";

type SOPUsageViewProps = {
  sopId: string;
};

export function SOPUsageView({ sopId }: SOPUsageViewProps) {
  const { data: usage, isLoading } = useSOPSUsage(sopId);

  if (isLoading) {
    return <div className="text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</div>;
  }

  if (!usage) {
    return <div className="text-muted-foreground text-sm">ບໍ່ພົບຂໍ້ມູນການນຳໃຊ້</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Users className="h-5 w-5 text-muted-foreground" />
        <h3 className="font-semibold">
          ຕໍາແໜ່ງທີ່ໃຊ້ SOP ນີ້ ({usage.positionCount})
        </h3>
      </div>
      {usage.positions.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {usage.positions.map((position) => (
            <Badge key={position.id} variant="outline">
              {position.title}
              {position.departmentName && (
                <span className="ml-1 text-muted-foreground">
                  ({position.departmentName})
                </span>
              )}
            </Badge>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground text-sm">ຍັງບໍ່ມີຕໍາແໜ່ງທີ່ໃຊ້ SOP ນີ້</p>
      )}

      <div className="flex items-center gap-2">
        <Building2 className="h-5 w-5 text-muted-foreground" />
        <h3 className="font-semibold">
          ພະແນກທີ່ໃຊ້ SOP ນີ້ ({usage.departmentCount})
        </h3>
      </div>
      {usage.departments.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {usage.departments.map((department) => (
            <Badge key={department.id} variant="outline">
              {department.name}
            </Badge>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground text-sm">ຍັງບໍ່ມີພະແນກທີ່ໃຊ້ SOP ນີ້</p>
      )}
    </div>
  );
}
